// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"297386b8","535":"77cdd183","536":"2b953f3c","829":"08e890e6"}[chunkId] + ".chunk.js";
};